<!-- 消息提示 -->
<template>
  <transition name="fade">
    <div v-if="visible"
         class="zlr-message">
      <div class="zlr-message-main">
        <Icon :type="iconOptions.type"
              :color="iconOptions.color"
              :size=42 />
        <span :style="{color: iconOptions.color}">{{content}}</span>
      </div>
    </div>
  </transition>
</template>
<script>
import './message.less'
export default {
  name: 'zlr-message',
  components: {},
  data () {
    return {
      content: '',
      time: 3000,
      visible: false,
      hasClose: false,
      type: 'success'
    }
  },
  render (createElement) {
    return createElement('div', '你好')
  },
  computed: {
    iconOptions () {
      let options = {
        type: '',
        color: ''
      }
      switch (this.type) {
        case 'success':
          options.type = 'md-checkmark-circle'
          options.color = '#4EAB4D'
          break
        case 'warning':
          options.type = 'ios-alert'
          options.color = '#FFA940'
          break
        case 'error':
          options.type = 'ios-close-circle'
          options.color = '#F5222D'
          break
      }
      return options
    }
  },
  mounted () {
    this.close()
  },
  methods: {
    close () {
      let timeOut = ''
      timeOut = setTimeout(() => {
        clearTimeout(timeOut)
        this.visible = false
      }, this.time)
    }
  }

}
</script>
